import React from 'react';
import classNames from 'classnames';
import { MemberAvatarProps, MemberItem } from '@fx-ui/jdy-design-biz';
import { Popover } from '@fx-ui/fine-design';
import { MemberType } from '~/interfaces';
import { MemberName, MemberAvatar, MemberCard } from '@fx-ui/platform-sdk';
import { tracker } from '~/utils';
import { TRACKER } from '~/constants';

interface MemberValueProps {
    className?: string;
    /**
     * 是否显示成员信息卡片
     */
    showViewCard?: boolean;
    /**
     * 触发成员信息卡片方式
     * @default click
     */
    trigger?: 'hover' | 'click';
    member: Partial<Pick<MemberItem, '_id' | 'type' | 'status' | 'nickname' | 'avatar'>>;
    /**
     * 头像与昵称间距
     * @default 4
     */
    gap?: number;
    avatarSize?: MemberAvatarProps['size'];
}

const MemberValue: React.FC<MemberValueProps> = ({
    className,
    showViewCard,
    trigger = 'click',
    member,
    gap = 4,
    avatarSize
}) => {
    const { _id, avatar, nickname = '', status, type = MemberType.internal } = member;

    const showCard = showViewCard && _id;

    const renderContent = () => {
        return (
            <div
                className={classNames('fx-member-value', className, {
                    'cursor-pointer': showCard
                })}
            >
                <MemberAvatar
                    className="member-avatar"
                    img={avatar}
                    name={nickname}
                    status={status}
                    size={avatarSize}
                />
                <MemberName
                    style={{ marginLeft: gap }}
                    className="member-name"
                    name={nickname}
                    status={status}
                    type={type}
                />
            </div>
        );
    };

    if (showCard) {
        return (
            <Popover
                trigger={trigger}
                placement="bottom-left"
                hasPadding={false}
                arrow={false}
                content={<MemberCard memberId={_id} />}
                onAfterPopupShow={() => {
                    if (trigger === 'click') {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_CLICK);
                    } else {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_HOVER);
                    }
                }}
            >
                {renderContent()}
            </Popover>
        );
    }

    return renderContent();
};

export default MemberValue;
